var MODULE_LABELS = {
  clientes: "Clientes",
  leads: "Leads",
  consorcios: "Consorcios",
  seguros: "Seguros",
  comissoes: "Comissoes",
  pagamentos: "Pagamentos",
  agenda: "Agenda",
  comunicacao: "Comunicacao",
  banners: "Banners",
  relatorios: "Relatorios",
  indicacoes: "Indicacoes",
  equipe: "Equipe",
  doletas: "DOLETAS",
};

var MODULES_WITH_EDIT = ["clientes", "leads", "consorcios", "seguros", "agenda"];

export default function AssistantPermissions({ permissions, onToggle }) {
  var modules = Object.keys(MODULE_LABELS);
  return (
    <div className="border border-gray-200 rounded-xl p-4" data-testid="assistant-permissions">
      <p className="text-xs font-semibold text-[#0A2F3D] mb-3 uppercase tracking-wider">Permissoes do Assistente</p>
      <div className="space-y-2">
        {modules.map(function(mod) {
          var perm = permissions[mod] || {};
          var hasEdit = MODULES_WITH_EDIT.indexOf(mod) >= 0;
          return (
            <div key={mod} className="flex items-center justify-between py-1.5 border-b border-gray-50 last:border-0">
              <span className="text-sm text-gray-700">{MODULE_LABELS[mod]}</span>
              <div className="flex items-center gap-3">
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <input type="checkbox" checked={!!perm.view}
                    onChange={function() { onToggle(mod, "view"); }}
                    className="w-4 h-4 rounded border-gray-300 text-[#3B82F6] focus:ring-[#3B82F6]"
                    data-testid={"perm-view-" + mod} />
                  <span className="text-xs text-gray-500">Ver</span>
                </label>
                {hasEdit && (
                  <label className="flex items-center gap-1.5 cursor-pointer">
                    <input type="checkbox" checked={!!perm.edit}
                      onChange={function() { onToggle(mod, "edit"); }}
                      className="w-4 h-4 rounded border-gray-300 text-[#F26A4B] focus:ring-[#F26A4B]"
                      data-testid={"perm-edit-" + mod} />
                    <span className="text-xs text-gray-500">Editar</span>
                  </label>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
